import NoTimesheets from './no-timesheets-row.component';
import NoParamMessage from './no-param-message.component';
import TimesheetRows from './timesheet-rows.component';
import HeaderDesktop from '../../../components/header-desktop.component';
import { Container, Table } from 'reactstrap';
import React from 'react';
import { IPendingTimesheetState } from './pending-timesheets.component';

const renderDesktop = ({
    approvalModal,
    error,
    hospitalName,
    isApproveDisabled,
    isLoading,
    payPeriod,
    payPeriodStart,
    payPeriodEnd,
    selectAll,
    setShowApproveModal,
    SHOW_MOCK_DATA,
    timesheets,
    toggleSelectAllRows,
    headerEl,
    contentEl,
    footerEl,
    userRequestedMockData,
}: IPendingTimesheetState): JSX.Element => {
    let timesheetRows = null;
    let hasTimesheets = false;
    let appMessaging = null;

    if (isLoading) {
        appMessaging = <NoTimesheets />;
    } else if ((!SHOW_MOCK_DATA || !userRequestedMockData) && !timesheets?.length) {
        appMessaging = <NoParamMessage />;
    } else if (error?.message) {
        appMessaging = <NoTimesheets message={'Unable to retrieve timesheets'} />;
    } else {
        hasTimesheets = true;
        timesheetRows = (
            <TimesheetRows
                {...{
                    payPeriodStart,
                    payPeriodEnd,
                    timesheets,
                }}
            />
        );
    }

    return (
        <div>
            <div className="desktop__page">
                <div ref={headerEl} className="tt-header">
                    <HeaderDesktop hospitalName={hospitalName} payPeriod={payPeriod} />
                </div>
                <Container fluid className="timesheet-table__container">
                    {appMessaging}
                    {hasTimesheets && (
                        <div ref={contentEl} className="timesheet-table__wrapper">
                            <Table responsive size={'lg'} className="timesheet-table">
                                <caption className="sr-only">List of timesheets to approve</caption>
                                <caption className="sr-only" role="alert">
                                    Please note: You must select at least one timesheet to approve.
                                </caption>
                                <tbody>
                                    <tr className="table-header">
                                        <td className="checkbox">
                                            <input
                                                id="select-all-timesheets"
                                                type="checkbox"
                                                checked={selectAll}
                                                onChange={toggleSelectAllRows}
                                            />
                                        </td>
                                        <td>
                                            <label htmlFor="select-all-timesheets" className="m-0 cursor-pointer">
                                                <span className="sr-only">Select all </span>Traveler
                                                <span className="sr-only">s</span>
                                            </label>
                                        </td>
                                        <td>Unit</td>
                                        <td>Regular Hours</td>
                                        <td>On Call Hours</td>
                                        <td>Call Back Hours</td>
                                        <td>Charge Hours</td>
                                        <td>Total Hours</td>
                                        <td />
                                    </tr>
                                    {timesheetRows}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Container>
            </div>
            {hasTimesheets && (
                <footer ref={footerEl} className="desktop__footer footer theme-green">
                    <Container fluid className="timesheet-table__container text-right">
                        <button
                            tabIndex={0}
                            onClick={() => setShowApproveModal(true)}
                            className="btn btn-primary hover-highlight rounded-pill stretched-link my-4 submit-button"
                            disabled={isApproveDisabled}
                        >
                            Approve
                            <span className="sr-only"> Selected timesheets (Opens a popup)</span>
                        </button>
                    </Container>
                </footer>
            )}
            {approvalModal}
        </div>
    );
};

export default renderDesktop;
